
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's05b70c60d4ea8317': `Tryk på "Åbn i browser..."`,
's182ab2d6c997515f': `Tilføj den til din hjemmeskærm for en bedre oplevelse og nem adgang.`,
's224cbcec014ef6b5': `Tryk på Del-knappen i navigationslinjen`,
's233af3b7eb5e0364': `Føj til startsiden`,
's37a9e8aec5713460': `Mere`,
's4c3161035f3a1413': `Tryk på menuen`,
's4e1e10a6ca408245': `Tryk på "Tilføj til hjemmeskærm"`,
's6196153c4b0c1ea0': `Installer`,
's633502f7cff4f847': `Åbn din browsermenu`,
's681e399d63311fba': `Vis galleri`,
's6d14a4f70ba4e3cf': `Tryk på menuen, hvis der ikke er noget Del-ikon`,
's922329d6f6213590': `Tilføj til Dock`,
's9c63a79ffcc2a3a3': `Tryk på "Tilføj til hjemmeskærm"`,
'sa2d71bfd9525168d': `Tryk på "Tilføj til Dock"`,
'sa5ef80b4bb9b39f8': `Mindre`,
'sb527eca1c1d7e7be': `Åbn browsermenuen i appen`,
'sba52286c21552a4e': `Installer den på din enhed for en bedre oplevelse og nem adgang.`,
'sc16e00a7a8b2fde2': `Tilbage`,
'scdaf4bbff76674c8': `Tilføj til hjemmeskærm`,
'sd18a5b85f599ff3c': `Åbn det kopierede link i Safari`,
'se72fc3a84f9b51c3': `Tryk for at kopiere linket`,
'se740f75b95a51807': `Tilføj den til din Dock for en bedre oplevelse og nem adgang.`,
'sfa6c42cdf48d93d2': `Men denne browser understøtter det ikke. Åbn linket i en ekstern browser for at fortsætte.`,
'sfb78526365796a41': `Tryk på "Vis mere" i Del-menuen`,
'sfea652f6580ff086': `Denne side har app-funktionalitet.`,
    };
  